<template>
  <div>
    <a class="button is-primary" :class="{ 'is-loading': isSavingGeneratingCheckList }" @click="generateCheckList()">Controlelijst genereren</a>

    <div class="columns">
      <div class="column is-6">
        <b-field label="Start datum">
          <b-datepicker
            placeholder="Start datum"
            icon="calendar"
            :readonly="false"
            v-model="startDate">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field label="Eind datum">
          <b-datepicker
            placeholder="Eind datum"
            icon="calendar"
            :readonly="false"
            v-model="endDate">
          </b-datepicker>
        </b-field>
      </div>
    </div>

    <hr>

    <div class="columns is-multiline">
      <div class="column is-12">
        <b-field label="Filteren op">
          <div class="block">
            <b-checkbox v-model="filterGroup"
                native-value="bonnummer">
                Bonnummer
            </b-checkbox>
            <b-checkbox v-model="filterGroup"
                native-value="datum">
                Datum
            </b-checkbox>
            <b-checkbox v-model="filterGroup"
                native-value="debiteur">
                Debiteur
            </b-checkbox>
            <b-checkbox v-model="filterGroup"
                native-value="crediteur">
                Crediteur
            </b-checkbox>
            <b-checkbox v-model="filterGroup"
                native-value="ritprijsChauffeur">
                Bedrag chauffeur
            </b-checkbox>
            <b-checkbox v-model="filterGroup"
                native-value="ritprijsFactuur">
                Bedrag klant
            </b-checkbox>
            <b-checkbox v-model="filterGroup"
                native-value="kostenplaats">
                Kostenplaats
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field label="Filteren">
            <b-input v-model="search"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-multiline">
      <b-table
        v-if="receipts.length > 0"
        :data="filteredReceipts"
        :paginated="true"
        :pagination-simple="false"
        :per-page="15"
        default-sort-direction="'asc'"
        default-sort="bonnummer">
        <template slot-scope="receipt">
          <b-table-column field="bonnummer" width="100" label="Nr." sortable numeric>
            {{ receipt.row.bonnummer }}
          </b-table-column>
          <b-table-column field="datum" label="Datum" sortable>
            {{ receipt.row.datum | date }}
          </b-table-column>
          <b-table-column field="debiteur" label="Debiteur" sortable>
            {{ receipt.row.debiteurNumber }}/{{ receipt.row.debiteur }}
          </b-table-column>
          <b-table-column field="crediteur" label="Crediteur" sortable>
            {{ receipt.row.crediteurNumber }}/{{ receipt.row.crediteur }}
          </b-table-column>
          <b-table-column field="ritprijsChauffeur" label="Bedrag chauffeur" sortable>
            {{ receipt.row.ritprijsChauffeur }}
          </b-table-column>
          <b-table-column field="ritprijsFactuur" label="Bedrag klant" sortable>
            {{ receipt.row.ritprijsFactuur }}
          </b-table-column>
          <b-table-column field="kostenplaats" label="Kostenplaats" sortable>
            {{ receipt.row.kostenplaats }}
          </b-table-column>
          <b-table-column label="Bekijken">
            <router-link class="button is-primary" :to="{ name: 'receipts.edit.concept', params: { id: receipt.row.id } }" exact>Bekijken</router-link>
          </b-table-column>
          <b-table-column label="Verwijderen">
            <span class="button is-danger" @click="deleteReceipt(receipt.row.id)" exact>Verwijderen</span>
          </b-table-column>
        </template>
      </b-table>

      <div class="column is-5" v-if="receipts.length <= 0">
        <article class="message is-info">
          <div class="message-header">
            <p>Geen bonnen gevonden</p>
          </div>
          <div class="message-body">
            Sla een bon op om gecontroleerd te worden.
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import checklist from './checklist'

export default {
  computed: {
    ...mapGetters({
      receipts: 'confirmationReceipts',
      checklist: 'checklist'
    }),
    filteredReceipts () {
      return this.receipts.filter(receipt => {
        const search = this.search.toLowerCase()

        if (!search) {
          return true
        }

        if (this.filterGroup.length <= 0) {
          return true
        }

        for (var key in receipt) {
          const isSelected = this.filterGroup.indexOf(key) >= 0
          if (!isSelected) {
            continue
          }

          const value = String(receipt[key]).toLowerCase()

          if (value.includes(search)) {
            return true
          }
        }

        return false
      })
    }
  },
  data () {
    return {
      search: '',
      isSavingGeneratingCheckList: false,
      filterGroup: [],
      startDate: new Date(),
      endDate: new Date()
    }
  },
  async created () {
    await this.$store.dispatch('getDebiteuren')
    await this.$store.dispatch('getCrediteuren')
    await this.$store.dispatch('getConfirmationReceipts')

    for (let index in this.receipts) {
      this.receipts[index].crediteurNumber = this.receipts[index].crediteur
      this.receipts[index].debiteurNumber = this.receipts[index].debiteur
      this.receipts[index].crediteur = this.$options.filters.crediteur(this.receipts[index].crediteur)
      this.receipts[index].debiteur = this.$options.filters.debiteur(this.receipts[index].debiteur)
    }
  },
  methods: {
    async generateCheckList () {
      this.isSavingGeneratingCheckList = true

      await this.$store.dispatch('generateCheckList', {
        startDate: this.startDate,
        endDate: this.endDate
      })

      this.isSavingGeneratingCheckList = false

      this.$modal.open({
        parent: this,
        component: checklist,
        props: {
          checklist: this.checklist
        }
      })
    },
    async deleteReceipt (id) {
      await this.$store.dispatch('deleteReceipt', id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/confirmation/index.vue